"use client";

import { useVillages } from "@entities/common";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import type { Ninja_Villages } from "@sisnaker-react-core/karirhub-model-type";
import { Combobox, type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

interface VillageComboboxProps {
  initialValue?: ComboboxOption | null;
  onChange: (value: ComboboxOption) => void;
  onClear?: () => void;
  disabled?: boolean;
  subDistrictIds?: string[];
}

export const VillageCombobox = ({ initialValue, onChange, onClear, disabled, subDistrictIds }: VillageComboboxProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const { villages, isLoading } = useVillages({ keyword, subDistrictIds, enabled: !disabled, page: 1, limit: 5 });

  const options: ComboboxOption[] = villages.map((village: Ninja_Villages) => ({
    value: village.id,
    label: village.name,
  }));

  return (
    <Combobox
      options={options}
      initialValue={initialValue}
      onChange={onChange}
      clearable
      searchable
      placeholder="Pilih kelurahan"
      searchPlaceholder="Cari kelurahan..."
      fallbackText={isLoading ? "Memuat..." : "Tidak ada data"}
      onSearch={(keyword) => setKeyword(keyword)}
      onClear={onClear}
      buttonProps={{
        disabled,
        className: "w-full",
      }}
      inputProps={{
        className: "w-full",
      }}
      appendIcon={<ChevronUpDownIcon className="size-5" />}
    />
  );
};
